kv.controller('ActivityBudgetVsActualFromExpenseReportShowCtrl', function($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
    var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);

    var params = kvUtils.getAllQueryParams();
    // vm.data = JSON.parse(vm.bladeParams.data);
    let rawData = JSON.parse(vm.bladeParams.data);
    // this data now contains an array by owner_name, with this structure:
    // [
    //   owner_id: 1, owner_name: "Owner 1", data: { ... }
    //   owner_id: 2, owner_name: "Owner 2", data: { ... }
    // ]
    // we need to transform it into an object with owner_id as key for easier access in the view

    vm.data = [];
    rawData.forEach(function(item) {
        vm.data[item.owner_id] = item.data.output;
    });

    console.log(vm.data);

    if (params) {
        if (params.generate) {
            $('[href="#results-tab"]').tab("show");
        }
    }

    $(document).ready(function() {
        $('#table1').DataTable({
            "paging":   false,
            "ordering": false,
            "info":     false,
            "bLengthChange": false
        });
        $('.dataTables_filter input[type="search"]').
        attr('placeholder','Search in table...').
        removeClass('input-small').
        css({'width':'350px','display':'inline-block'});

        $('.dataTables_filter').addClass('pull-right').addClass('no-print');
    });

    vm.openDetails = function(activity_budget){
        vm.collapse_code = null;
        let className = $('#reference_icon_' + activity_budget).attr('class');
        if(className == 'fa fa-caret-right'){
            vm.collapse_code = activity_budget + "-open";
            $('#reference_icon_' + activity_budget).removeClass('fa fa-caret-right').addClass('fa fa-caret-down');

        } else {
            vm.collapse_code = activity_budget + "-close";
            $('#reference_icon_' + activity_budget).removeClass('fa fa-caret-down').addClass('fa fa-caret-right');
        }

    };

    /**
     * show details popup
     * @param params
     */
    vm.showDetailsPopup = function (params) {
        params = JSON.parse(params);
        var popupData = vm.data[params.owner_id][params.agg_id]['budget_lines'][params.budget_line_id]['practices'][params.detail_id]['ym'][params.ym]['details'];
        console.log(popupData);
        console.log(params);

        vm.openModal({
            templateUrl: "activity-budget-vs-actual-from-expense-details",
            controller: 'ActivityBudgetVsActualFromExpenseReportDetailsCtrl',
            controllerAs: 'vm',
            size: 'xl',
            resolve: {
                params: {
                    entity: popupData,
                    month: params.ym_label,
                    practiceName: params.practice_name,
                }
            }
        });
    };

    return vm;
});
